// Guide registry — each entry is a guide definition consumed by <GuidedFlow>.
// A guide: { key, title, makeSteps(engine, ctx) -> steps[] }.
//
// Phase 1 ships three entity guides (data source, processing rule, data target)
// plus the original full New-Project pipeline guide. Each guide is domain-agnostic
// and drives the real cortex assistant chat with non-asking prompts, gating each
// step on ground-truth reads so the overlay advances on real state.
import { dataSourceGuide } from "./dataSource";
import { processingRuleGuide } from "./processingRule";
import { dataTargetGuide } from "./dataTarget";

export const GUIDES = {
  data_source: dataSourceGuide,
  processing_rule: processingRuleGuide,
  data_target: dataTargetGuide,
};

export function getGuide(key) {
  return GUIDES[key] || null;
}
